<template>
  <a-modal :visible="visible" :closable="false" class="imagePicker">
    <template slot="title">{{ $t('label.selectFomGallery') }}</template>
    <div class="container">
      <div v-for="(image, index) in imageList" :key="image" @click.prevent="selected = index" :class="[selected === index && 'selected']">
        <img :src="image" />
      </div>
    </div>

    <template slot="footer">
      <a-button @click="$emit('onClosed')">{{ $t('button.cancel') }}</a-button>
      <a-button :disabled="selected === ''" type="primary" @click="handleSelected">{{ $t('button.continue') }}</a-button>
    </template>
  </a-modal>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    demoList: [
      'Abstract 2.jpg',
      'Abstract Banner.jpg',
      'Bible Banner.jpg',
      'Church Banner.jpg',
      'Clouds Banner.jpg',
      'Cross Banner.jpg',
      'Everlasting Love.jpg',
      'Guest Banner.jpg',
      'Jesus Worship Banner.jpg',
      'Join Us Banner.jpg',
      'Lights.jpg',
      'Mountain Banner.jpg',
      'Ocean.jpg',
      'Placeholder Banner.jpg',
      'Weary Rest.jpg',
      'Welcome Banner.jpg',
    ],
    selected: '',
  }),
  computed: {
    imageList() {
      return this.demoList.map(item => `/resources/images/demo/${item}`);
    },
  },
  methods: {
    handleSelected() {
      this.$emit('onSelected', this.imageList[this.selected]);
    },
  },
};
</script>
<style lang="scss">
.imagePicker {
  .ant-modal {
    width: 100% !important;
    max-width: 80vw;
    top: initial;
    &-wrap {
      justify-content: center;
      align-items: center;
      display: flex;
    }
    &-body {
      max-height: 70vh;
      overflow: auto;
      padding: 0;
      .container {
        max-width: initial;
        padding: 10px;
        > div {
          margin-bottom: 20px;
          position: relative;
          &::after {
            content: '';
            transition: background-color 0.3s;
          }
          img {
            width: 100%;
            border-radius: 10px;
          }
          &:last-child {
            margin: 0;
          }
          &:hover {
            &::after {
              font-size: 24px;
              border-radius: 10px;
              width: 100%;
              height: 100%;
              background-color: rgba(#000, 0.1);
              position: absolute;
              top: 0;
              left: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              color: #fff;
            }
          }
          &.selected {
            &::before {
              content: '✔';
              font-size: 30px;
              color: #76ff03;
              position: absolute;
              top: -20px;
              right: -10px;
            }
          }
        }
      }
    }
    &-footer {
      padding: 10px;
    }
  }
}
</style>
